import { addImposterToUrl } from 'Utils';
import { api } from '../axios';

const baseURL = '/Otp';

export interface IRequestBody {
  userIsrId: string;
  phone?: string;
  emailAddress?: string;
}

export interface IGenerateOTPCode extends IRequestBody {
  isSms: boolean;
}

export interface IVerifyOTPCode extends IRequestBody {
  otpCode: string;
}

export const generateOtpCode = async (body: IGenerateOTPCode) => {
  const otpCode = await api.post(
    addImposterToUrl(`${baseURL}/generate`, true),
    body,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return otpCode;
};

export const otpCodeValidation = async (body: IVerifyOTPCode) => {
  const verifyOtpCode = await api.post(
    addImposterToUrl(`${baseURL}/verify`, true),
    body,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  if (verifyOtpCode.data) return verifyOtpCode;
  else return verifyOtpCode.request;
};
